import { actionType } from "./index";

const initialState: any = {};

export default (state: any = initialState, { type, payload }: actionType) => {
  switch (type) {
    case "UPDATE_TRANSLATIONS":
      return payload;
    default:
      return state;
  }
};
